<template>
  <custom-popup
    v-model="internalDialog"
    :cons="{
      title: 'طراحی و ساخت گروهی کیوآرکد برای موارد انتخاب شده',
      icon: 'qrcode',
    }"
    max-width="1200"
  >
    <v-card-text class="pt-5">
      <v-row>
        <!-- ستون سمت راست (راست‌چین): پیش‌نمایش -->
        <v-col cols="12" md="4" style="height: fit-content">
          <img
            v-if="qrSvgDataUrl"
            :src="qrSvgDataUrl"
            alt="QR Preview"
            class="cursor-pointer"
            width="100%"
            style="
              border-radius: 10px;
              max-height: 350px;
              object-fit: contain;
              border: 1px solid #eee;
            "
          />
          <v-skeleton-loader
            v-else
            type="image"
            height="350"
          ></v-skeleton-loader>
        </v-col>

        <!-- ستون سمت چپ: تنظیمات -->
        <v-col cols="12" md="8">
          <div
            class="d-flex justify-space-between align-center mb-2"
            v-if="qrDesignMode === 'manual'"
          >
            <span
              style="
                direction: rtl;
                text-align: right;
                color: #666;
                font-size: 14px;
              "
            >
              لطفا پس از تنظیم دیزاین دستی، روی دکمه پیش‌نمایش کیوآرکد کلیک
              کنید.
            </span>
            <v-btn
              :loading="previewLoading"
              class="btn-download rounded-lg"
              outlined
              :disabled="
                (qrDesignMode === 'manual' && !hasChanges) || previewLoading
              "
              @click="handlePreviewClick"
            >
              پیش‌نمایش <v-icon right>mdi-refresh</v-icon>
            </v-btn>
          </div>

          <v-col cols="12" style="height: fit-content">
            <!-- انتخابگر نوع ساخت کیوآرکد -->
            <div class="mb-4 text-right">
              <p
                class="font-weight-bold mb-2"
                style="color: #001554; direction: rtl"
              >
                <v-icon color="warning">mdi-qrcode-scan</v-icon> طراحی کیوآرکد
              </p>

              <v-radio-group
                v-model="qrDesignMode"
                row
                class="mt-0"
                style="direction: rtl"
              >
                <v-radio
                  label="خودکار (طراحی تصادفی)"
                  value="auto"
                  color="primary"
                  @click="generateRandomDesign(false)"
                ></v-radio>
                <v-radio
                  label="دستی (شخصی‌سازی رنگ و فرم)"
                  value="manual"
                  color="primary"
                ></v-radio>
              </v-radio-group>
            </div>

            <v-slide-y-transition>
              <div v-show="qrDesignMode === 'auto'" class="text-right mb-4">
                <v-btn
                  outlined
                  class="btn-download rounded-lg"
                  @click="generateRandomDesign(false)"
                >
                  <v-icon left>mdi-shuffle</v-icon> ساخت تصادفی جدید
                </v-btn>
              </div>
            </v-slide-y-transition>

            <v-slide-y-transition>
              <div v-show="qrDesignMode === 'manual'">
                <v-expansion-panels
                  v-model="activeQrPanels"
                  class="px-0"
                  flat
                  accordion
                >
                  <v-expansion-panel
                    v-for="(item, i) in qrPanels"
                    :key="'qr-' + i"
                    class="mb-4"
                  >
                    <v-expansion-panel-header class="text-right">
                      <div class="d-flex justify-space-between align-center">
                        <div>
                          <v-icon class="me-2 text-muted"
                            >mdi-{{ item.icon }}</v-icon
                          >
                          {{ item.title }}
                        </div>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="py-5 text-right">
                      <component
                        :is="item.name"
                        v-model="options"
                        :colors="colors"
                        :readonly="false"
                        :design-object="getDesignObject(item.name)"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </v-slide-y-transition>
          </v-col>
        </v-col>
      </v-row>

      <v-alert
        type="info"
        outlined
        dense
        class="mt-4 text-right"
        style="direction: rtl"
      >
        این دیزاین روی <strong>{{ selectedIds.length }}</strong> شناسه انتخاب
        شده اعمال خواهد شد.
      </v-alert>
    </v-card-text>

    <v-card-actions class="d-flex justify-space-between pb-4 pr-4">
      <v-btn class="btn-delete rounded-lg" @click="internalDialog = false"
        ><v-icon small>mdi-close</v-icon>انصراف</v-btn
      >

      <v-btn
        v-if="generationSuccess && generatedDownloadLink"
        class="btn-download rounded-lg"
        @click="forceDownload(generatedDownloadLink, 'QRs.zip')"
      >
        <v-icon right>mdi-download</v-icon> دانلود فایل نهایی
      </v-btn>

      <v-btn
        v-else
        class="btn-get-code rounded-lg"
        :loading="isGenerating"
        :disabled="selectedIds.length === 0"
        @click="generateFilesForIds"
      >
        <v-icon right>mdi-check</v-icon> اعمال دیزاین و ساخت
      </v-btn>
    </v-card-actions>
  </custom-popup>
</template>

<script>
import QrCodeDataAdv from "@/view/pages/qrland/qrCodeStyle/components/qrCodeDataAdv";
import QrCodeDotsAdv from "@/view/pages/qrland/qrCodeStyle/components/qrCodeDotsAdv";
import QrCodeEyeAdv from "@/view/pages/qrland/qrCodeStyle/components/qrCodeEyeAdv";
import QrCodeOptions from "@/view/pages/qrland/qrCodeStyle/components/qrCodeOptions";
import QrCodeSquareAdv from "@/view/pages/qrland/qrCodeStyle/components/qrCodeSquareAdv";
import QrCodeFrameAdv from "@/view/pages/qrland/qrCodeStyle/components/qrCodeFrameAdv";
import QrCodeLogoAdv from "@/view/pages/qrland/qrCodeStyle/components/qrCodeLogoAdv";

export default {
  name: "MassQrDesignPopup",
  components: {
    QrCodeDataAdv,
    QrCodeDotsAdv,
    QrCodeEyeAdv,
    QrCodeOptions,
    QrCodeSquareAdv,
    QrCodeFrameAdv,
    QrCodeLogoAdv,

  },
  props: {
    value: { type: Boolean, default: false },
    selectedIds: { type: Array, default: () => [] },
  },
  data() {
    return {
      qrDesignMode: "auto",
      activeQrPanels: [],
      hasChanges: false,
      previewLoading: false,
      isGenerating: false,
      generationSuccess: false,
      generatedDownloadLink: "",
      qrSvgDataUrl: "",

      designObject_dots: [],
      designObject_patttern: [],
      designObject_square: [],
      designObject_frames: [], 
      designObject_logos: [],


      options: {
        outer_frame: "bottom",
        framelabel: "مرا اسکن کنید",
        label_font: "Parastoo.ttf",
        "label-text-size": 100,
        framecolor: "#1754ec",
        custom_frame_color: "on",

        optionlogo: "02-email-b.png",
        no_logo_bg: "on",
        logo_size: 100,
        different_borders_color: false,
        different_eyes_color: false,
        marker_out_color: "#000000",
        marker_in_color: "#000000",
        marker_top_right_center: "#000000",
        marker_top_right_outline: "#000000",
        marker_bottom_left_outline: "#000000",
        marker_bottom_left_center: "#000000",
        different_markers_color: false,
        width: 300,
        height: 300,
        data: "example.com",
        margin: 5,
        qrOptions: { typeNumber: 0, mode: "Byte", errorCorrectionLevel: "H" },
        imageOptions: { hideBackgroundDots: true, imageSize: 0.4, margin: 0 },
        dotsOptions: {
          type: "extra-rounded",
          color: "#000000",
          gradient: null,
        },
        backgroundOptions: { color: "transparent", gradient: null }, // تنظیم پس‌زمینه به شفاف
        cornersSquareOptions: {
          type: "extra-rounded",
          gradient: null,
          color: "#000000",
        },
        cornersDotOptions: { type: "", color: "#000000", gradient: null },
      },

      colors: [
        ["#649173", "#DBD5A4"],
        ["#B993D6", "#8CA6DB"],
        ["#870000", "#190A05"],
        ["#00d2ff", "#3a7bd5"],
        ["#DAD299", "#B0DAB9"],
        ["#E6DADA", "#274046"],
        ["#50C9C3", "#96DEDA"],
        ["#4b6cb7", "#182848"],
        ["#EC6F66", "#F3A183"],
        ["#5f2c82", "#49a09d"],
      ],

      qrPanels: [
        {
          name: "QrCodeDotsAdv",
          title: "طراحی نقاط کیوآرکد",
          icon: "dots-triangle",
        },
        {
          name: "QrCodeEyeAdv",
          title: "طراحی چشم داخلی کیوآرکد",
          icon: "bullseye",
        },
        {
          name: "QrCodeSquareAdv",
          title: "طراحی حاشیه کیوآرکد",
          icon: "rounded-corner",
        },
        { name: "QrCodeFrameAdv", title: "طراحی قاب", icon: "border-all" }, 
        { name: "QrCodeLogoAdv", title: "تنظیمات لوگو", icon: "image" }, 

        {
          name: "QrCodeOptions",
          title: "تنظیمات پیشرفته کیوآرکد",
          icon: "cogs",
        },
      ],
    };
  },
  computed: {
    internalDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    internalDialog(val) {
      if (val) {
        this.generationSuccess = false;
        this.generatedDownloadLink = "";
        if (!this.qrSvgDataUrl) this.updatePreview();
      }
    },
    qrDesignMode(newVal) {
      if (newVal === "auto") {
        this.generateRandomDesign(false);
      }
    },
    options: {
      handler() {
        this.hasChanges = true;
        this.generationSuccess = false;
      },
      deep: true,
    },
  },
  mounted() {
    this.fetchDesigns();
    this.generateRandomDesign(true);
    setTimeout(() => {
      this.updatePreview();
    }, 500);
  },
  methods: {
    cleanPayload(obj) {
      const cleaned = {};
      Object.keys(obj).forEach((key) => {
        if (obj[key] !== null && obj[key] !== undefined) {
          cleaned[key] = obj[key];
        }
      });
      return cleaned;
    },

    isGradient(opt) {
      let res = {
        color: "",
        color1: "",
        isGradient: false,
      };
      if (opt && opt.hasOwnProperty("gradient") && !!opt.gradient) {
        res = {
          isGradient: true,
          color: opt.gradient.colorStops[0].color,
          color1: opt.gradient.colorStops[1].color,
        };
      } else if (opt) {
        res = {
          isGradient: false,
          color: opt.color,
          color1: null,
        };
      }
      return res;
    },

    getDesignObject(name) {
      if (name === "QrCodeDotsAdv") return this.designObject_patttern;
      if (name === "QrCodeEyeAdv") return this.designObject_dots;
      if (name === "QrCodeSquareAdv") return this.designObject_square;
      if (name === 'QrCodeFrameAdv')  return this.designObject_frames;
      if (name === 'QrCodeLogoAdv') return this.designObject_logos;

      return [];
    },

    fetchDesigns() {
      this.$api
        .get("/v2/qr-gen/markers")
        .then(({ data }) => {
          const apiData = data.data;
      this.designObject_patttern = Object.keys(apiData.pattern || {}).map((key) => ({ value: key, img: apiData.pattern[key] }));
      this.designObject_dots = Object.keys(apiData.markerIn || {}).map((key) => ({ value: key, img: apiData.markerIn[key] }));
      this.designObject_square = Object.keys(apiData.markerOut || {}).map((key) => ({ value: key, img: apiData.markerOut[key] }));
      
      this.designObject_frames = Object.keys(apiData.frames || {}).map((key) => ({ 
        value: key, 
        data: apiData.frames[key] 
      }));
      
      this.designObject_logos = Object.keys(apiData.logos || {}).map((key) => ({ 
        value: key, 
        img: apiData.logos[key].preview 
      }));
    })
    .catch(() => {});
    },

    generateRandomDesign(isInitial = false) {
      this.qrDesignMode = "auto";
      const getRandomItem = (arr) => {
        if (!arr || arr.length === 0) return null;
        return arr[Math.floor(Math.random() * arr.length)].value;
      };
      const getRandomDarkColor = () => {
        return `#${Math.floor(Math.random() * 150)
          .toString(16)
          .padStart(2, "0")}${Math.floor(Math.random() * 150)
          .toString(16)
          .padStart(2, "0")}${Math.floor(Math.random() * 150)
          .toString(16)
          .padStart(2, "0")}`;
      };

      this.options.dotsOptions.type =
        getRandomItem(this.designObject_patttern) || "rounded";
      this.options.cornersSquareOptions.type =
        getRandomItem(this.designObject_square) || "extra-rounded";
      this.options.cornersDotOptions.type =
        getRandomItem(this.designObject_dots) || "dot";

      if (isInitial || true) {
        this.options.different_borders_color = false;
        this.options.different_eyes_color = false;
        this.options.dotsOptions.color = "#000000";
        this.options.marker_out_color = "#000000";
        this.options.marker_in_color = "#000000";
        this.options.cornersSquareOptions.color = "#000000";
        this.options.cornersDotOptions.color = "#000000";
      this.options.outer_frame= "bottom";
      this.options.framelabel= "مرا اسکن کنید";
      this.options.label_font= "Parastoo.ttf";
      this.options["label-text-size"]= 100;
      this.options.framecolor= "#000000";
      this.options.custom_frame_color= "on";
      this.options.optionlogo= "";
      this.options.no_logo_bg= "on";
      this.options.logo_size= 100;

      } else {
        this.options.different_borders_color = true;
        this.options.different_eyes_color = true;
        this.options.dotsOptions.color = getRandomDarkColor();
        this.options.marker_out_color = getRandomDarkColor();
        this.options.marker_in_color = getRandomDarkColor();
      this.options.outer_frame= "bottom";
      this.options.framelabel= "مرا اسکن کنید";
      this.options.label_font= "Parastoo.ttf";
      this.options["label-text-size"]= 100;
      this.options.framecolor= "#000000";
      this.options.custom_frame_color= "on";
      this.options.optionlogo= "";
      this.options.no_logo_bg= "on";
      this.options.logo_size= 100;

        
      }

      this.updatePreview();
    },

    getQrDesignParams() {
      const opt = this.options;

      let backgroundColor = this.isGradient(opt.backgroundOptions);
      let frontColor = this.isGradient(opt.dotsOptions);
      let cornerSquare = this.isGradient(opt.cornersSquareOptions);
      let cornerDots = this.isGradient(opt.cornersDotOptions);

      const hasDifferentMarkers =
        opt.different_borders_color || opt.different_eyes_color;

      return {
        transparent: "on",
        level: opt.qrOptions.errorCorrectionLevel || "H",
        pattern: opt.dotsOptions.type || "ellipse",
        marker_out: opt.cornersSquareOptions.type || "sdoz",
        marker_in: opt.cornersDotOptions.type || "sdoz",

        backcolor: backgroundColor.color || "transparent",
        color: frontColor.color,
        radial: false,
        gradient: frontColor.isGradient,
        gradient_color: frontColor.color1,

        marker_out_color: opt.different_borders_color
          ? opt.marker_out_color
          : cornerSquare.color,
        marker_top_right_outline: opt.different_borders_color
          ? opt.marker_top_right_outline
          : cornerSquare.color,
        marker_bottom_left_outline: opt.different_borders_color
          ? opt.marker_bottom_left_outline
          : cornerSquare.color,

        marker_in_color: opt.different_eyes_color
          ? opt.marker_in_color
          : cornerDots.color,
        marker_top_right_center: opt.different_eyes_color
          ? opt.marker_top_right_center
          : cornerDots.color,
        marker_bottom_left_center: opt.different_eyes_color
          ? opt.marker_bottom_left_center
          : cornerDots.color,

        different_markers_color: hasDifferentMarkers,

        markers_color: hasDifferentMarkers,
        
        outer_frame: opt.outer_frame,
        framelabel: opt.framelabel,
        label_font: opt.label_font,
        "label-text-size": opt["label-text-size"],
        framecolor: opt.custom_frame_color === 'on' ? opt.framecolor : '',
        custom_frame_color: opt.custom_frame_color,
        
        optionlogo: opt.optionlogo,
        no_logo_bg: opt.no_logo_bg,
        logo_size: opt.logo_size,
      };
    },

    handlePreviewClick() {
      if (this.qrDesignMode === "auto") {
        this.generateRandomDesign(false);
      } else {
        this.updatePreview();
      }
    },

    updatePreview() {
      if (!this.ribbon_can("nfc_add_reserve_qr_code")) return;
      this.previewLoading = true;
      try {
        const payload = this.cleanPayload({
          ...this.getQrDesignParams(),
          id: this.selectedIds[0] || 1,
        });
        this.$api
          .post("/admin/nfc/gen-image", payload)
          .then((res) => {
            const imgData = res.data.data || res.data;
            if (typeof imgData === "string" && imgData.includes("http")) {
              this.qrSvgDataUrl = imgData + "?t=" + new Date().getTime();
            } else if (
              typeof imgData === "string" &&
              imgData.includes("<svg")
            ) {
              this.qrSvgDataUrl = `data:image/svg+xml;utf8,${encodeURIComponent(
                imgData,
              )}`;
            } else if (
              typeof imgData === "string" &&
              imgData.includes("data:image")
            ) {
              this.qrSvgDataUrl = imgData;
            } else {
              this.qrSvgDataUrl = `data:image/svg+xml;base64,${imgData}`;
            }
            this.hasChanges = false;
            this.$forceUpdate();
          })
          .catch(() => {
            this.$toast.error("خطا در دریافت پیش‌نمایش");
          })
          .finally(() => {
            this.previewLoading = false;
          });
      } catch (err) {
        console.error(err);
        this.previewLoading = false;
        this.$toast.error("خطا در پردازش اطلاعات");
      }
    },

    generateFilesForIds() {
      if (!this.ribbon_can("nfc_add_reserve_qr_code")) return;
      this.isGenerating = true;
      this.generationSuccess = false;
      try {
        const finalQrOptions = this.getQrDesignParams();
        this.$api
          .post("/admin/nfc/gen-image/bulk", {
            ids: this.selectedIds,
            ...finalQrOptions,
          })
          .then((response) => {
            let dataUrl = response.data.data || response.data;
            if (typeof dataUrl === "string" && dataUrl.includes("/api/")) {
              dataUrl = dataUrl.replace("/api/", "/");
            }
            this.generatedDownloadLink = dataUrl;
            this.generationSuccess = true;
            this.$toast.success(
              "فایل با موفقیت ساخته شد. حالا روی دکمه دانلود کلیک کنید.",
            );
          })
          .catch(() => {
            this.$toast.error("خطا در ساخت کیوآرکدها");
          })
          .finally(() => {
            this.isGenerating = false;
          });
      } catch (err) {
        console.error(err);
        this.isGenerating = false;
        this.$toast.error("خطا در پردازش اطلاعات ارسالی");
      }
    },

    forceDownload(url, filename) {
      try {
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename || "qrcodes.zip");

        link.setAttribute("target", "_blank");

        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          document.body.removeChild(link);
        }, 100);
      } catch (error) {
        console.error("Error initiating download:", error);
        window.open(url, "_blank");
      }
    },
  },
};
</script>

<style scoped>
.v-expansion-panel {
  border-radius: 15px !important;
  box-shadow: 8px 5px 10px #f49d1a;
}
.v-expansion-panel
  >>> .v-expansion-panel-header.v-expansion-panel-header--active {
  background-color: #001554 !important;
  border-radius: 15px !important;
  color: whitesmoke !important;
}
.v-expansion-panel
  >>> .v-expansion-panel-header.v-expansion-panel-header--active
  .v-icon {
  color: whitesmoke !important;
}
.submit-btn {
  border-radius: 10px;
  font-weight: bold;
}
.file-card {
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid transparent;
}
.file-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
  border-color: #e0e0e0;
}
.selected-card {
  background-color: #f0f7ff !important;
  border: 1px solid #1976d2 !important;
}
.file-name {
  color: #333;
  font-weight: 500;
}
</style>
